import {
    CollectionDataLoaded,
    ContentDataDefinitionLoader,
    createRegisterableComponentWithData,
} from '@news-mono/web-common'
import { MaybeLoaded } from 'json-react-layouts-data-loader'
import React, { useContext } from 'react'
import { CollectionDataContext } from '../../contexts'
import { ArticleCardList, ArticleCardListProps } from './ArticleCardList'

export const ArticleCardListRegistration = createRegisterableComponentWithData(
    'article-card-list',
    ContentDataDefinitionLoader,
    (
        {
            expectedItemCount,
            interlacedComponents,
            adTargeting,
        }: Omit<ArticleCardListProps, 'items' | 'onEvent'>,
        { dataDefinitionArgs, ...initialData },
        { onEvent },
    ) => {
        const { getCollectionData } = useContext(CollectionDataContext)

        const contextId =
            dataDefinitionArgs.type === 'context'
                ? dataDefinitionArgs.contextId
                : undefined

        let data: MaybeLoaded<CollectionDataLoaded> = initialData
        if (contextId) {
            data = getCollectionData(contextId)
        }

        return (
            <ArticleCardList
                items={
                    data.loaded
                        ? {
                              loaded: true,
                              result: data.result.publications,
                          }
                        : { loaded: false }
                }
                expectedItemCount={expectedItemCount}
                onEvent={onEvent}
                adTargeting={adTargeting}
                interlacedComponents={interlacedComponents}
            />
        )
    },
)
